const checkIsLocalhost = () => window.location.hostname === "localhost";

export default checkIsLocalhost;
